export enum IPlannerPropertyRoomType {
    Room = 0,
    Kitchen = 1,
    Bathroom = 2
}
export enum IPlannerPropertyRoomType {
    Room = 0,
    Kitchen = 1,
    Bathroom = 2
}
